// Estados do workflow do Portal de Justificativas.
// Espelha o enum de justificativaInfo.status em vision_be/models/Request.js.
//
// Fluxo:
//   JUSTIFICAR ──(Amerinode justifica)───▶ AGUARDANDO_APROVACAO
//   AGUARDANDO_APROVACAO ─(Vivo abona)───▶ ABONADO   (aprovada — terminal)
//   AGUARDANDO_APROVACAO ─(Vivo recusa)──▶ RECUSADO   (1ª recusa — cabe réplica)
//   RECUSADO ─(Amerinode replica, 1 vez)─▶ AGUARDANDO_APROVACAO
//   AGUARDANDO_APROVACAO ─(Vivo recusa de novo)─▶ NAO_ACEITO (definitivo — terminal)
//
// A Vivo também pode ir direto para NAO_ACEITO já na 1ª avaliação, pelo botão
// "Não aceito" — nesse caso não há etapa de réplica.
//
// Descontinuados (mantidos só para registros antigos):
//   ACEITO     — unificado em ABONADO
//   EM_REPLICA — a recusa passou a ir direto para RECUSADO
const StatusJustificativa = {
    JUSTIFICAR:           { descricao: "Aguardando Justificativa", cor: "#3B82F6" }, // blue-500
    AGUARDANDO_APROVACAO: { descricao: "Aguardando Aprovação",     cor: "#10B981" }, // emerald-500
    EM_REPLICA:           { descricao: "Em Réplica",               cor: "#F59E0B" }, // amber-500
    ABONADO:              { descricao: "Abonado",                  cor: "#22C55E" }, // green-500 — status final de aprovação
    RECUSADO:             { descricao: "Recusado",                 cor: "#EF4444" }, // red-500 — cabe réplica
    NAO_ACEITO:           { descricao: "Não Aceito",                cor: "#991B1B" }, // red-800 — recusa definitiva
};

export default StatusJustificativa;
